let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("atNxX")).then(() => parcelRequire('jE6uv'));